import { render, staticRenderFns } from "./TicketWrapper.vue?vue&type=template&id=aeed6982&scoped=true"
import script from "./TicketWrapper.vue?vue&type=script&lang=ts"
export * from "./TicketWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TicketWrapper.vue?vue&type=style&index=0&id=aeed6982&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeed6982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeed6982')) {
      api.createRecord('aeed6982', component.options)
    } else {
      api.reload('aeed6982', component.options)
    }
    module.hot.accept("./TicketWrapper.vue?vue&type=template&id=aeed6982&scoped=true", function () {
      api.rerender('aeed6982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/TicketWrapper.vue"
export default component.exports